module.exports = __webpack_public_path__ + "img/missionaries2_2019_7-7-2021.70531df6.jpg";